import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FinanceDashboardComponent } from './finance-dashboard/finance-dashboard.component';
import { RechargeRecoveryComponent } from './recharge-recovery/recharge-recovery.component';
import { HolidayCalendarModalComponent } from './holiday-calendar-modal/holiday-calendar-modal.component';
import { ConfirmEmailModalComponent } from './confirm-email-modal/confirm-email-modal.component';
import { FinanceDetailsComponent } from './finance-details/finance-details.component';
import { FilterByModalComponent } from './finance-details/filter-by-modal/filter-by-modal.component';
import { ImportDataModalComponent } from './finance-details/import-data-modal/import-data-modal.component';
import { FinanceRateCardComponent } from './finance-details/finance-rate-card/finance-rate-card.component';
import { FinanceTierRatesComponent } from './finance-details/finance-tier-rates/finance-tier-rates.component';
import { FinanceProjectsComponent } from './finance-details/finance-projects/finance-projects.component';
import { FinanceRoutingModule } from './finance-routing.module';

@NgModule({
  declarations: [
    FinanceDashboardComponent,
    RechargeRecoveryComponent,
    HolidayCalendarModalComponent,
    ConfirmEmailModalComponent,
    FinanceDetailsComponent,
    FilterByModalComponent,
    ImportDataModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FinanceRoutingModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSortModule,
    MatPaginatorModule,
    NgxSkeletonLoaderModule,
    FinanceRateCardComponent,
    FinanceTierRatesComponent,
    FinanceProjectsComponent,
  ],
})
export class FinanceModule {}
